module.exports = __webpack_public_path__ + "img/pingan.47e9da69.png";